module.exports = __webpack_public_path__ + "static/2.Day-Trading Risk Disclosure Statement-551bf3a0bfc38d44e8622a859c3fd2fa.pdf";